<template>
	<el-row class="all_box">
		<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="hzdw_box">
			<el-divider content-position="left">
				<span style="color: rgb(3, 125, 9)">下属单位</span>
			</el-divider>

			<div class="dw_conten xsdw_container">
				<div class="dw_item" v-for="(itz, inx) in xsdwArr" :key="inx">
					<img :src="itz.icon" alt="" />
				</div>
			</div>
		</el-col>

		<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="hzdw_box">
			<el-divider content-position="left">
				<div style="color: rgb(3, 125, 9)">合作公司</div>
			</el-divider>

			<div class="dw_conten hzgs_container">
				<div class="dw_item" v-for="(itz, inx) in hzgsArr" :key="inx">
					<img :src="itz.icon" alt="" />
				</div>
			</div>
		</el-col>

		<el-col class="footer_box">
			<div>蜀ICP备2020025972号</div>
			<div>雅安市名山区国有资产投资经营有限责任公司</div>
		</el-col>
	</el-row>
</template>

<script setup>
import http from "@/utils/api";
import { ref, watch, onMounted, defineProps } from "vue";
import { useStore } from 'vuex';

const store = useStore();
let usersObj = ref({
	unitId: "",
});

const props = defineProps({
	nubFoot: {
		type: Number,
		default: 1,
	},
});

// 组件挂载时检查登录状态
onMounted(() => {
	if (store.state.isLoggedIn) {
		getHzgs();
		getXsdw();
	}
});

	//公司项目
	let hzgsArr = ref([]);
	let getHzgs = async () => {
		let res = await http.base.NewsQuery({
			page: 1,
			limit: 100,
			orgId: '',
			date: "",
			select: "type,url,createDate,content,title,secTitle,icon",
			where: `type like '%ccHzgs%'`,
			sortby: "sort desc",
		});
		if (res && res.code == 0) {
			hzgsArr.value = res.data.data || [];
		}
	};

	//下属单位
	let xsdwArr = ref([]);
	let getXsdw = async () => {
		let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
		let res = await http.base.NewsQuery({
			page: 1,
			limit: 100,
			orgId: userInfo.unitId || "102",
			date: "",
			select: "type,url,createDate,content,title,secTitle,icon",
			where: `type like '%ccXsdw%'`,
			sortby: "sort desc",
		});
		if (res && res.code == 0) {
			xsdwArr.value = res.data.data || [];
		}
	};

watch(
	() => props.nubFoot,
	(newValue, oldValue) => {
		usersObj.value = JSON.parse(sessionStorage.getItem("userInfo"));
	}, {
		deep: true,
		immediate: true,
	}
);
// 监听仓库中的登录状态变化
watch(() => store.state.isLoggedIn, (newVal) => {
  if (newVal) {
    getHzgs();
		getXsdw();
  }
});
</script>
<style scoped lang="scss">
.all_box {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #fff;
}

.hzdw_box {
	width: 100%;
	min-height: 110px;
	margin: 0 auto;
	padding: 0px 10px;
	
	.dw_conten {
		width: 100%;
		min-height: 76px;
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		
		.dw_item {
			height: 66px;
			border: 1px solid #ccccccb5;
			
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
}

/* PC端样式 - 保持原有布局 */
@media (min-width: 768px) {
	.hzdw_box {
		.dw_conten {
			.dw_item {
				width: 260px;
				margin-right: 10px;
			}
		}
	}
}

/* 移动端样式 */
@media (max-width: 767px) {
	/* 下属单位 - 每行2个 */
	.xsdw_container {
		.dw_item {
			width: calc(49% - 5px);
		}
	}
	
	/* 合作公司 - 每行3个 */
	.hzgs_container {
		.dw_item {
			width: calc(32% - 7px);
		}
	}
}

.footer_box {
	width: 100%;
	background-color: #ddd !important;
	text-align: center;
	border-top: 3px solid #2c7;
	color: #999 !important;
	padding: 20px;
	font-size: 14px;
	line-height: 20px;
	margin-top: 20px;
}

@media screen and (max-width: 768px) {
	.footer_box {
		padding: 15px 10px;
		font-size: 12px;
	}
}
</style>